import algoliasearch from "algoliasearch";

/**
  * Saved Favorites handler
  *
  */
//console.log(tgblPEFrontend_e)
const PEFavorites = ($) => {

  if (!window.Tangible) return

  const tangibleSelect = window.Tangible.Select
  const ajax = window.Tangible.ajax
  const ajaxConfig = window.Tangible.ajaxConfig

  const tgblPEFrontend_json = window.atob(tgblPEFrontend_e)
  const tgblPEFrontend = jQuery.parseJSON(tgblPEFrontend_json)
  const LOCALIZED = tgblPEFrontend.localized

  //const LOCALIZED = tgblPEFrontend.localized

  // Global object
  window.PEFavoritesFunctions = {}

  $(document).ready(function () {
    window.PEFavoritesFunctions.constructor()
  })

  window.PEFavoritesFunctions = {

    // initialize the code
    constructor: function () {

      const $_this =this;

      const favorite_actions__js = $('.favorite-actions--js')
      const tgbl_instantsearch_container__js= $('.tgbl-instantsearch-container--js')
      if(favorite_actions__js.length || tgbl_instantsearch_container__js.length) {
        this.saveToFavorites(favorite_actions__js,$_this)
      }
      const user_saved_favorites_list__js = $('.user-saved-favorites-list--js')
      if(user_saved_favorites_list__js.length) {
        this.removeFromSavedFavoritesList(parent,$_this)
      }
      this.toolTip()
    },

    toolTip: function(type) {

      if(type == undefined) type = 'favorites'

      $( 'body' ).tooltip({
        items: '[data-tooltip_'+type+']',
        content: function() {
          const element = $( this )
          return element.attr('data-tooltip_'+type)
        },
        //position: { my: "left+15 center", at: "right center" },
        position: { my: "right center", at: "left-10 center" },
      })
    },

    saveToFavorites: function (parent,$_this) {

      //console.log($_this)

      $('body').on('click','.favorite-actions--js',function(e){
        e.stopImmediatePropagation()
        const $this = $(this)

        const user_id = $this.attr('data-user_id')
        const post_id = $this.attr('data-post_id')
        const reload_page = ($this.attr('data-reload_page') != undefined) ? $this.attr('data-reload_page') : 0

        //console.log('---- clicked ----')

        const button = $this.find('.favorite-button--js .text--js')
        const button_sr = $this.find('.favorite-button--js .screen-reader--js')
        const icon = $this.find('.favorite-icon--js .text--js')
        const icon_sr = $this.find('.favorite-icon--js .screen-reader--js')

        // if we are on instantsearch find wrapper
        const ais_pec_item_wrapper = $this.parents('.pec-item-wrapper--js')
        const ais_container = $this.parents('.tgbl-instantsearch-container--js')

        const data = {
          user_id: user_id,
          post_id: post_id,
        }

        //$('.favorite-actions--js').not(this).each(function(){
        $('.favorite-actions--js').each(function(){
          $(this).css('opacity', '0.2').css('pointer-events', 'none')
        })

        // ajax handle user save resource

        ajax('tgbl_user_saved_favorite_ajax', data)
          .then(function(res) {
            //console.log('RESPONSE --- ',  res)
            $this.attr('data-saved',res.saved)

            // Algolia search client
            const searchClient = algoliasearch(
              window.atob(res.aaid),
              window.atob(res.aak)
            );
            const index = searchClient.initIndex('wp_posts_sfwd-courses');

            if(res.saved === 1){
                $this.addClass('saved')
                $this.removeClass('not-saved')
                $this.attr('data-tooltip_favorites',LOCALIZED.remove_favorites)
                button_sr.text(LOCALIZED.remove_favorites)
                icon_sr.html(LOCALIZED.remove_favorites)

              // if we are in ais
              if(ais_pec_item_wrapper.length){

                // if we are in header
                if($this.parents('.pec-item-header--js').length){
                  ais_pec_item_wrapper.find('.pec-item-footer--js .favorite-actions--js').addClass('saved').removeClass('not-saved').attr('data-tooltip_favorites',LOCALIZED.remove_favorites)
                  ais_pec_item_wrapper.find('.pec-item-footer--js .favorite-button--js .screen-reader--js').text(LOCALIZED.remove_favorites)
                  ais_pec_item_wrapper.find('.pec-item-footer--js .favorite-icon--js .screen-reader--js').text(LOCALIZED.remove_favorites)

                // if we are in footer
                } else if($this.parents('.pec-item-footer--js').length){
                  ais_pec_item_wrapper.find('.pec-item-header--js .favorite-actions--js').addClass('saved').removeClass('not-saved').attr('data-tooltip_favorites',LOCALIZED.remove_favorites)
                  ais_pec_item_wrapper.find('.pec-item-header--js .favorite-button--js .screen-reader--js').text(LOCALIZED.remove_favorites)
                  ais_pec_item_wrapper.find('.pec-item-header--js .favorite-icon--js .screen-reader--js').text(LOCALIZED.remove_favorites)
                }

                // Update user saved favorites data attribute - ais_container
                //const previously_saved = ais_container.attr('data-user_saved_favorites')
                ais_container.attr('data-user_saved_favorites',JSON.stringify(res.new_saved))

              }

              // update index
              index.getObject(post_id + '-0', {
                attributesToRetrieve: ['course_users_favorites']
              }).then(object => {

                const course_users_favorites =[...new Set(object['course_users_favorites'])]   // make the array unique
                course_users_favorites.push(user_id)

                index.partialUpdateObject({
                  //course_users_favorites: course_users_favorites,
                  course_users_favorites: [...new Set(course_users_favorites)],  // make the array unique
                  objectID: post_id + '-0'
                }).then(({ objectID }) => {
                  console.log(objectID)
                  if(reload_page){
                    console.log('reload_page ',  reload_page)
                    window.location.reload()
                  }
                })
              })

              setTimeout(function(){
               //$_this.toolTip('favorites')
                window.PEFavoritesFunctions.toolTip('favorites')
              }, 400)

              $('.favorite-actions--js').each(function(){
                $(this).css('opacity', '1').css('pointer-events', 'inherit')
              })

            } else if(res.saved === 0){
              $this.removeClass('saved')
              $this.addClass('not-saved')
              $this.attr('data-tooltip_favorites',LOCALIZED.add_favorites)
              button_sr.html(LOCALIZED.add_favorites)
              icon_sr.html(LOCALIZED.add_favorites)

              // if we are in instantsearch
              if(ais_pec_item_wrapper.length){

                // if we are in header
                if($this.parents('.pec-item-header--js').length){
                  ais_pec_item_wrapper.find('.pec-item-footer--js .favorite-actions--js').removeClass('saved').addClass('not-saved').attr('data-tooltip_favorites',LOCALIZED.add_favorites)
                  ais_pec_item_wrapper.find('.pec-item-footer--js .favorite-button--js .screen-reader--js').text(LOCALIZED.add_favorites)
                  ais_pec_item_wrapper.find('.pec-item-footer--js .favorite-icon--js .screen-reader--js').text(LOCALIZED.add_favorites)

                  // if we are in footer
                } else if($this.parents('.pec-item-footer--js').length){
                  ais_pec_item_wrapper.find('.pec-item-header--js .favorite-actions--js').removeClass('saved').addClass('not-saved').attr('data-tooltip_favorites',LOCALIZED.add_favorites)
                  ais_pec_item_wrapper.find('.pec-item-header--js .favorite-button--js .screen-reader--js').text(LOCALIZED.add_favorites)
                  ais_pec_item_wrapper.find('.pec-item-header--js .favorite-icon--js .screen-reader--js').text(LOCALIZED.add_favorites)
                }

                ais_container.attr('data-user_saved_favorites',JSON.stringify(res.new_saved))

              }

              // update index
              index.getObject(post_id + '-0', {
                attributesToRetrieve: ['course_users_favorites']
              }).then(object => {

                const course_users_favorites =[...new Set(object['course_users_favorites'])]  // make the array unique

                //course_users_favorites.push(user_id)
                const pos = course_users_favorites.lastIndexOf(user_id)

                if(pos !== -1){
                  course_users_favorites.splice(pos,1)

                  index.partialUpdateObject({
                    course_users_favorites: [...new Set(course_users_favorites)],  // make the array unique
                    objectID: post_id + '-0'
                  }).then(({ objectID }) => {
                    console.log(objectID)
                    if(reload_page){
                      console.log('reload_page ',  reload_page)
                      window.location.reload()
                    }
                  })
                }
              })

              setTimeout(function(){
                window.PEFavoritesFunctions.toolTip('favorites')
              }, 400)

              $('.favorite-actions--js').each(function(){
                $(this).css('opacity', '1').css('pointer-events', 'inherit')
              })
            }

          })
          .catch(function(err) {
            console.log('error - ',  err)
          }) // end ajax
      }) // end click
    },


    removeFromSavedFavoritesList: function (parent,$_this) {

      $('body').on('click','.favorite-actions-remove--js',function(){
        const $this = $(this)
        const user_id = $this.attr('data-user_id')
        const post_id = $this.attr('data-post_id')
        const reload_page = $this.attr('data-reload_page')

        const data = {
          user_id: user_id,
          post_id: post_id,
        }

        // spinner
        const spinnerHtml = $(tgblPEFrontend.spinnerHtml)
        $this.parents('.user-saved-favorites-list--js').css('opacity','0.5').append(spinnerHtml)
        spinnerHtml.find('.tgbl-ajax-modal-spinner').show()

        // ajax handle user saved favorite remove

        ajax('tgbl_remove_user_saved_favorites_ajax', data)
          .then(function(res) {

            //console.log('RESPONSE --- ',  res)
            if(res.success == true){
              $this.parents('.user-saved-favorites-list--js').html(res.html).css('opacity','1')
              spinnerHtml.remove()

              // Algolia search client
              const searchClient = algoliasearch(
                window.atob(res.aaid),
                window.atob(res.aak)
              );
              const index = searchClient.initIndex('wp_posts_sfwd-courses');

              // update index
              index.getObject(post_id + '-0', {
                attributesToRetrieve: ['course_users_favorites']
              }).then(object => {

                const course_users_favorites =[...new Set(object['course_users_favorites'])]  // make the array unique

                //course_users_favorites.push(user_id)
                const pos = course_users_favorites.lastIndexOf(user_id)

                if(pos !== -1){
                  course_users_favorites.splice(pos,1)

                  index.partialUpdateObject({
                    course_users_favorites: [...new Set(course_users_favorites)],  // make the array unique
                    objectID: post_id + '-0'
                  }).then(({ objectID }) => {
                    console.log(objectID)
                    if(reload_page){
                      console.log('reload_page ',  reload_page)
                      window.location.reload()
                    }
                  })
                }
              })
            }
          })
          .catch(function(err) {
            console.log('error - ',  err)
          }) // end ajax
      }) // end click
    },
  }
}
export {PEFavorites}
